import { ThemeProvider, createTheme } from "@mui/material";
import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ContextProvider } from "../../context/Context";

const theme = createTheme({
  typography: {
    fontFamily: ["Telefonica", "sans-serif"].join(","),
  },
});

const Layout = () => {
  return (
    <ContextProvider>
      <Suspense fallback={<div></div>}>
        <ThemeProvider theme={theme}>
          <main>{<Outlet />}</main>
        </ThemeProvider>
      </Suspense>
    </ContextProvider>
  );
};

export default Layout;
